import { useState } from "react";
import { useBoardManager } from "../../../BoardsManagerProvider";
import { ActivityCard } from "../ActivityCard/ActivityCard";
import "./BoardColumnTable.css";
import useModal, { MODAL_LG } from "../../../../../theme/Component/hooks/useModal";
import { Modal } from "../../../../../theme/Component/Modal";
import { SelectWorkActivityTaskType } from "../../../../WorkActivityTaskType/SelectWorkActivityTaskType";
import { SelectWorkActivityType } from "../../../../WorkActivityType/SelectWorkActivityType";
import { SelectWorkActivityPriority } from "../../../../WorkActivityPriority/SelectWorkActivityPriority";
import { InputDate } from "../../../../../theme/Input/InputDate";
import { SelectWorkActivityStatuses } from "../../../../WorkActivityStatuses/SelectWorkActivityStatuses";
import { AccountEditor } from "../../../../../editor/AccountEditor";
import { PrintJson } from "../../../../../theme/Component/PrintJson";
import { _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import { SelectWorkActivityGroup } from "../../../../WorkActivityGroup/SelectWorkActivityGroup";
import { SelectWorkActivityGroupUserByIDAccount } from "../../../../WorkActivityGroup/WorkActivityGroupUser/SelectWorkActivityGroupUserByIDAccount";

type WorkActivity = {
  Name: string;
  WorkActivityCode: string;
  FromDate: any;
  IDWorkActivityGroup: number;
  DefeatDate: any;
  IDEmployee: number;
  IDWorkActivityStatuses: number;
  IDSolver: number;
  IDReporter: number;
  UptoDate: any;
  IDWorkActivityPriority: number;
  IDWorkActivityType: number;
  IDWorkActivityTaskType: number;
  Description: string;
  IDSprint: number;
  StatusesFinished: boolean;
  State: number;
}

export const BoardColumnTable = ({ column, items }) => {

  const { relations, updateStateActivity, sprintId, IDAccount, updateWorkActivity } = useBoardManager();

  const modal = useModal("Agregar Tarea", MODAL_LG);
  const modalSelect = useModal("Tareas Disponibles", MODAL_LG);

  const [bean, setBean] = useState<Partial<WorkActivity>>({
    IDReporter: _single.getAccountID(),
    IDEmployee: IDAccount,
    IDSprint: sprintId,
    State: 1
  });

  const bashBean = () => {
    setBean({
      IDReporter: _single.getAccountID(),
      IDEmployee: IDAccount,
      IDSprint: sprintId,
      State: 1
    })
  }

  const col = column.DataBeanProperties;
  const [isHover, setIsHover] = useState<boolean>(false);

  const getStatusByColumn = (columnId: number) => {
    const rels = relations.filter(
      r =>
        r.DataBeanProperties.IDBoardColumn === columnId &&
        r.DataBeanProperties.IsActive
    );

    if (rels.length === 0) return null;

    if (rels.length === 1) {
      return rels[0].DataBeanProperties.IDWorkActivityStatuses;
    }

    const primary = rels.filter(
      r => r.DataBeanProperties.IsPrimary === 1
    );

    if (primary.length > 0) {
      return primary[0].DataBeanProperties.IDWorkActivityStatuses;
    }
    console.log(rels[0].DataBeanProperties)

    return rels[0].DataBeanProperties.IDWorkActivityStatuses;
  };

  return (
    <>
      <div className="board-column">
        <div className="board-column__header" style={{ background: col.HeaderColor ?? "#266cbc" }} >
          <span className="board-column__title">
            {col.BoardColumnsName}
          </span>

          <span className="board-column__count">
            {items.length}
          </span>
        </div>

        <div
          className="board-column__body"
          onMouseEnter={() => setIsHover(true)}
          onMouseLeave={() => setIsHover(false)}
          onDragOver={(e) => e.preventDefault()}
          onDrop={(e) => {
            const activityId = Number(
              e.dataTransfer.getData("activityId")
            );

            const columnId = col.IDBoardColumns;
            const newStatus = getStatusByColumn(columnId);

            if (!newStatus) return;

            updateStateActivity(
              activityId,
              newStatus,
              _single.getAccountID()
            );
          }}
        >
          {items.map(item => (
            <ActivityCard
              key={item.DataBeanProperties.IDWorkActivity}
              activity={item}
            />
          ))}

          {isHover &&
            <div className="empty-column">
              <button className="empty-column__btn" onClick={() => { modal.open() }}>
                + Crear tarea
              </button>
            </div>
          }

          {/* {isHover &&
            <div className="empty-column">
              <button className="empty-column__btn" onClick={() => { modal.open() }}>
                Seleccionar tarea
              </button>
            </div>
          } */}
        </div>
      </div>

      <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { updateWorkActivity(bean, () => { modal.close(); bashBean(); }) }} >
        <div className="row">
          <div className="col-md-6">
            <label>Nombre de la Tarea</label>
            <input type="text" className="form-control" value={bean.Name} onChange={(e) => { setBean({ ...bean, Name: e.target.value }) }} />
          </div>
          <div className="col-md-6">
            <label>Codigo de la Tarea</label>
            <input type="text" className="form-control" value={bean.WorkActivityCode} onChange={(e) => { setBean({ ...bean, WorkActivityCode: e.target.value }) }} />
          </div>
          <div className="col-md-6">
            <InputDate notDate label="Fecha de Inicio" name="" value={bean.FromDate} setDate={(e) => { setBean({ ...bean, FromDate: e }) }} withTime />
          </div>
          <div className="col-md-6">
            <InputDate notDate label="Fecha de Vencimiento" name="" value={bean.DefeatDate} setDate={(e) => { setBean({ ...bean, DefeatDate: e }) }} withTime />
          </div>
          {!IDAccount &&
            <div className="col-md-12">
              <div className="row">
                <div className="col-md-6">
                  <SelectWorkActivityGroup label="Areas Disponibles" idSelector={bean.IDWorkActivityGroup} onChange={(e) => { setBean({ ...bean, IDWorkActivityGroup: e }) }} />
                </div>
                {bean.IDWorkActivityGroup &&
                  <div className="col-md-6">
                    <SelectWorkActivityGroupUserByIDAccount label="Responsable" idGroup={bean.IDWorkActivityGroup} idSelector={bean.IDEmployee} onChange={(e) => { setBean({ ...bean, IDEmployee: e }) }} />
                  </div>
                }
              </div>
            </div>
          }
          <div className="col-md-6">
            <label>Estado</label>
            <SelectWorkActivityStatuses label=" " idSelector={bean.IDWorkActivityStatuses} onChange={(e) => { setBean({ ...bean, IDWorkActivityStatuses: e.IDWorkActivityStatuses, StatusesFinished: e.IsDone }) }} returnType="Object" />
          </div>
          {bean.StatusesFinished &&
            <>
              <div className="col-md-6">
                <InputDate notDate label="Fecha de Finalización" name="" value={bean.UptoDate} setDate={(e) => { setBean({ ...bean, UptoDate: e }) }} withTime />
              </div>
            </>
          }
          <div className="col-md-6">
            <label>Prioridad</label>
            <SelectWorkActivityPriority label=" " idSelector={bean.IDWorkActivityPriority} onChange={(e) => { setBean({ ...bean, IDWorkActivityPriority: e }) }} />
          </div>
          <div className="col-md-6">
            <label>Tipo de Tarea</label>
            <SelectWorkActivityType label=" " idSelector={bean.IDWorkActivityType} onChange={(e) => { setBean({ ...bean, IDWorkActivityType: e }) }} />
          </div>
          <div className="col-md-6">
            <label>Clasificación</label>
            <SelectWorkActivityTaskType label=" " idSelector={bean.IDWorkActivityTaskType} onChange={(e) => { setBean({ ...bean, IDWorkActivityTaskType: e }) }} />
          </div>
          <div className="col-md-12">
            <label>Descripción</label>
            <textarea className="form-control" value={bean.Description} onChange={(e) => { setBean({ ...bean, Description: e.target.value }) }} />
          </div>
        </div>
      </Modal>

    </>
  );
};
